import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="relative">
      <Navbar />
      <main>
        {/* Page Header */}
        <ContactHero />

        {/* Content */}
        <section className="py-20 md:py-28 px-6 md:px-16 lg:px-24 bg-stone-100">
          <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            {/* Contact Info + Map */}
            <div className="flex flex-col h-full">
              <div className="flex-1 flex flex-col justify-center">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
                  Hablemos
                </h2>
                <p className="text-gray-600 leading-relaxed mb-8">
                  Nos encantaría saber de usted. Contacte con nuestro equipo para cualquier consulta sobre nuestros productos, servicios u oportunidades de colaboración.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                  <div>
                    <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-2">
                      Oficina Central
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Bogotá Colombia<br />
                      Av. de las Américas # 62-11
                    </p>
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-2">
                      Teléfono
                    </h3>
                    <p className="text-gray-600 text-sm">+57 311 2245754</p>
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-2">
                      Correo Electrónico
                    </h3>
                    <p className="text-gray-600 text-sm">comercial@esenciayco.co</p>
                  </div>
                </div>
              </div>

              {/* Map */}
              <div className="mt-10">
                <div className="mb-3">
                  <p className="text-xs uppercase tracking-[0.25em] text-gray-500 mb-1">Ubicación</p>
                  <h3 className="text-base font-bold text-gray-900">Sede Central — Bogotá</h3>
                </div>
                <div className="w-full rounded-lg overflow-hidden shadow-sm">
                  <iframe
                    src="https://www.google.com/maps?q=Av.+de+las+Am%C3%A9ricas+%2362-11,+Bogot%C3%A1,+Colombia&output=embed"
                    width="100%"
                    height="240"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Ubicación Sede Central Esencia&co."
                    className="w-full"
                  />
                </div>
                <div className="flex flex-wrap gap-4 mt-3">
                  <a
                    href="https://maps.google.com/?cid=3738784561070558443&hl=es-419&gl=CO"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 transition-colors"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-map-pin-line text-base" />
                    </span>
                    Ver en Google Maps
                  </a>
                  <a
                    href="https://www.waze.com/ul?q=Av.%20de%20las%20Am%C3%A9ricas%20%2362-11,%20Bogot%C3%A1,%20Colombia"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 transition-colors"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-navigation-line text-base" />
                    </span>
                    Abrir en Waze
                  </a>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="bg-white p-8 md:p-10 rounded-lg shadow-sm h-full flex flex-col">
              {submitted ? (
                <div className="flex-1 flex flex-col items-center justify-center text-center py-12">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-check-line text-2xl text-green-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">¡Gracias!</h3>
                  <p className="text-gray-600">Nos pondremos en contacto con usted pronto.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="flex-1 flex flex-col space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Nombre
                    </label>
                    <input
                      type="text"
                      required
                      value={formData.name}
                      onChange={(e) =>
                        setFormData({ ...formData, name: e.target.value })
                      }
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400 text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Correo Electrónico
                    </label>
                    <input
                      type="email"
                      required
                      name="email"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400 text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Empresa
                    </label>
                    <input
                      type="text"
                      value={formData.company}
                      onChange={(e) =>
                        setFormData({ ...formData, company: e.target.value })
                      }
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400 text-sm"
                    />
                  </div>
                  <div className="flex-1 flex flex-col">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Mensaje
                    </label>
                    <textarea
                      rows={5}
                      maxLength={500}
                      required
                      value={formData.message}
                      onChange={(e) =>
                        setFormData({ ...formData, message: e.target.value })
                      }
                      className="w-full flex-1 min-h-[120px] px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400 text-sm resize-none"
                    />
                    <p className="text-xs text-gray-400 mt-1 text-right">
                      {formData.message.length}/500
                    </p>
                  </div>
                  <button
                    type="submit"
                    className="w-full px-8 py-4 bg-gray-900 text-white text-sm tracking-widest uppercase hover:bg-gray-800 transition-colors rounded-md"
                  >
                    Enviar Mensaje
                  </button>
                </form>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}